import React from 'react';
import {
    Box,
} from '@mui/material';
import PageLoader from '../../../components/pageloader/pageLoader';

const PolicyFooter = ({policyData}) => {

    const policyContentRef = React.useRef();
    const [openLoader, setOpenLoader] = React.useState(false);

    React.useEffect(() => {
        setOpenLoader(true);
        let refData = 'No Data'
        if (policyData?.footer) {
            refData = policyData?.footer;
        }
        if (policyContentRef.current) {
            policyContentRef.current.innerHTML = refData;

            // Force all links to open in a new tab
            const links = policyContentRef.current.querySelectorAll('a');
            links.forEach(link => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });

            
        }
        
        setOpenLoader(false);
    }, [policyContentRef, policyData]);

    
    return (
        <Box>
            {policyData?.footer && policyData?.footer?.trim().length>0 && (<>{/*<h2 className="sectionHeading">Footer</h2>*/}
            <div className="preview-header-section" style={{marginTop: '20px'}} >
                <PageLoader openLoader={openLoader} />
                <div ref={policyContentRef}></div>
            </div></>)}
        </Box>
    )

}

export default PolicyFooter;